import {
    isNavigationFailure, NavigationFailureType, type RouteLocationNormalized, type RouteLocationNormalizedLoaded, type NavigationFailure
} from 'vue-router';
import { showNavigationError } from '../../store/errorState';

export function NavigationErrorGuard(to: RouteLocationNormalized, from: RouteLocationNormalizedLoaded, failure?: NavigationFailure | void) {
    showNavigationError.value.show = false;
    if (isNavigationFailure(failure, NavigationFailureType.aborted)) {
        showNavigationError.value.show = true;
        showNavigationError.value.route = to;
    }
}
